import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyWithdrawals } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./FundsWithdrawalPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const truncateHash = (str, head = 8, tail = 6) => {
  if (!str || str.length <= head + tail) return str;
  return `${str.slice(0, head)}...${str.slice(-tail)}`;
};

const TABS = [
  { key: "COMPLETED", label: "Complete", status: "COMPLETED" },
  { key: "PENDING", label: "Pending", status: "PENDING" },
  { key: "CANCELLED", label: "Cancelled", status: "CANCELLED" },
];

const FundsWithdrawalPage = () => {
  const [withdrawals, setWithdrawals] = useState(dummyWithdrawals);
  const [activeTab, setActiveTab] = useState("PENDING");
  const [search, setSearch] = useState("");
  const [viewBank, setViewBank] = useState(null);

  const filtered = withdrawals.filter((w) => {
    const matchStatus = w.status === activeTab;
    const matchSearch =
      !search ||
      w._id?.toLowerCase().includes(search.toLowerCase()) ||
      w.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      w.emailId?.toLowerCase().includes(search.toLowerCase()) ||
      w.short_name?.toLowerCase().includes(search.toLowerCase());
    return matchStatus && matchSearch;
  });

  const counts = {
    COMPLETED: withdrawals.filter((w) => w.status === "COMPLETED").length,
    PENDING: withdrawals.filter((w) => w.status === "PENDING").length,
    CANCELLED: withdrawals.filter((w) => w.status === "CANCELLED").length,
  };

  const handleStatusChange = (id, newStatus) => {
    setWithdrawals((prev) =>
      prev.map((w) => (w._id === id ? { ...w, status: newStatus } : w))
    );
  };

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Funds Withdrawal</span>
          </p>
          <h1 className="dashboard-hero__title">Funds Withdrawal</h1>
          <p className="dashboard-hero__subtitle">
            Process and track withdrawal requests
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-arrow-up" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="withdrawal-section">
          <div className="withdrawal-section__header">
            <div className="withdrawal-section__title-wrap">
              <span className="withdrawal-section__icon">
                <i className="fas fa-money-bill-wave" />
              </span>
              <h2 className="withdrawal-section__title">Withdrawal Requests</h2>
            </div>
            <div className="withdrawal-section__stats">
              {TABS.map((tab) => (
                <span key={tab.key} className="withdrawal-stat">
                  <strong>{counts[tab.key] ?? 0}</strong> {tab.label}
                </span>
              ))}
            </div>
          </div>

          <div className="withdrawal-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                type="button"
                className={`withdrawal-tab ${activeTab === tab.status ? "withdrawal-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.status)}
              >
                {tab.label} ({counts[tab.key] ?? 0})
              </button>
            ))}
          </div>

          <div className="withdrawal-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by ID, user ID, email or currency..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="withdrawal-search-input"
            />
          </div>

          <div className="withdrawal-table-wrap">
            <table className="withdrawal-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Created</th>
                  <th>User ID</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Chain</th>
                  <th>Currency</th>
                  <th>To Address / Bank</th>
                  <th>Amount</th>
                  <th>Fee</th>
                  <th>Payment</th>
                  <th>Status</th>
                  {activeTab === "PENDING" && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row._id}>
                    <td><span className="withdrawal-mono">{row._id}</span></td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td><span className="withdrawal-mono">{row.user_id}</span></td>
                    <td>{row.emailId}</td>
                    <td>{row.mobileNumber}</td>
                    <td>{row.chain}</td>
                    <td><strong>{row.short_name}</strong></td>
                    <td>
                      {row.payment_type === "FIAT" && row.user_bank ? (
                        <button
                          type="button"
                          className="withdrawal-bank-btn"
                          onClick={() => setViewBank(row)}
                        >
                          {row.user_bank.bank_name} <i className="fas fa-external-link-alt" />
                        </button>
                      ) : (
                        <span className="withdrawal-hash" title={row.to_address}>
                          {row.to_address ? truncateHash(row.to_address) : "—"}
                        </span>
                      )}
                    </td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td>{typeof row.fee === "number" ? row.fee.toLocaleString("en-IN", { minimumFractionDigits: 4 }) : row.fee}</td>
                    <td><span className={`withdrawal-payment withdrawal-payment--${(row.payment_type || "").toLowerCase()}`}>{row.payment_type}</span></td>
                    <td>
                      <span className={`withdrawal-status withdrawal-status--${(row.status || "").toLowerCase()}`}>
                        {row.status}
                      </span>
                    </td>
                    {activeTab === "PENDING" && (
                      <td>
                        <div className="withdrawal-actions">
                          <button
                            type="button"
                            className="withdrawal-btn withdrawal-btn--approve"
                            onClick={() => handleStatusChange(row._id, "COMPLETED")}
                          >
                            <i className="fas fa-check" /> Complete
                          </button>
                          <button
                            type="button"
                            className="withdrawal-btn withdrawal-btn--cancel"
                            onClick={() => handleStatusChange(row._id, "CANCELLED")}
                          >
                            <i className="fas fa-times" /> Cancel
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filtered.length === 0 && (
            <p className="withdrawal-empty">No {activeTab.toLowerCase()} withdrawals.</p>
          )}
        </section>
      </div>

      {/* Bank details modal (FIAT) */}
      {viewBank?.user_bank && (
        <div className="withdrawal-modal-overlay" onClick={() => setViewBank(null)}>
          <div className="withdrawal-modal" onClick={(e) => e.stopPropagation()}>
            <div className="withdrawal-modal__header">
              <h3>Bank Details</h3>
              <button type="button" className="withdrawal-modal__close" onClick={() => setViewBank(null)} aria-label="Close">
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="withdrawal-modal__body">
              <dl className="withdrawal-dl">
                <div><dt>Bank Name</dt><dd>{viewBank.user_bank.bank_name}</dd></div>
                <div><dt>Account Holder</dt><dd>{viewBank.user_bank.account_holder_name}</dd></div>
                <div><dt>Account Number</dt><dd className="withdrawal-mono">{viewBank.user_bank.account_number}</dd></div>
                <div><dt>IFSC</dt><dd className="withdrawal-mono">{viewBank.user_bank.ifsc_code}</dd></div>
                <div><dt>Branch</dt><dd>{viewBank.user_bank.branch_address}</dd></div>
              </dl>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default FundsWithdrawalPage;
